
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cegah-diabetes",
      function () {
        return require("private-next-pages/cegah-diabetes/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cegah-diabetes"])
      });
    }
  